/**
 * Returns modifier class based on the payment type
 * @param {object} opts
 * @param {string}opts.type
 * @returns {*}
 */
const getPaymentClass = (opts = {}) => {
  switch (opts.type) {
    case 'master':
    case 'mastercard':
      return 'payment-info__img--master';
    default:
      return `payment-info__img--${opts.type}`;
  }
};

export default getPaymentClass;
